import { uniq } from "lodash-es";

import { type ExternalItem } from "shared/resources";
import useMentionCountsStore from "shared/stores/mentionCounts";
import useStreamsStore from "shared/stores/streams";

async function saveExternalItems(externalItems: ExternalItem[]) {
  await Promise.all(
    externalItems.map((externalItem: ExternalItem) =>
      externalItem.saveResource({ with: ["streamsExternalItems"] })
    )
  );

  await clearStreamMentionCounts(externalItems);
}

async function clearStreamMentionCounts(externalItems: ExternalItem[]) {
  const { getStreamById } = useStreamsStore();
  const { clearMentionsCount } = useMentionCountsStore();

  const streamIds = uniq(
    externalItems.flatMap(
      (externalItem) =>
        externalItem.streamsExternalItems?.map(
          (streamExternalItems) => streamExternalItems.streamId
        ) || []
    )
  );

  await Promise.all(
    streamIds.map(async (streamId) => {
      const stream = getStreamById(streamId);

      if (!stream) return;

      const requireStreamRefresh = (externalItem: ExternalItem) =>
        !stream.refreshed_at ||
        new Date(externalItem.publishedAt) > new Date(stream.refreshed_at);

      const associatedExternalItems = externalItems.filter((ei) =>
        ei.streamsExternalItems?.some((sei) => sei.streamId === streamId)
      );

      if (associatedExternalItems.some(requireStreamRefresh)) {
        await clearMentionsCount(stream);
      }
    })
  );
}

export { saveExternalItems };
